/* CHS v2 symptom pages (layout/chs2 loads this after chs2.js on page templates whose suffix contains "symptom").
   The formula box: size pills (when a page offers more than one size), Subscribe & Save vs one-time, interval pills,
   and the gold "Subscribe · $X" / "Add to cart · $X". Prices are cents from Liquid; every word comes from the section
   settings (data-sx-data "labels"), so a wording change is an editor change, not a code change.
   Cart adds go through window.CHS2.postAdd (XHR), because UpCart wraps window.fetch and strips selling_plan.
   The box mirrors its state on data-sx-cur-* attributes (never on the control attributes, which the click handler
   looks up with closest()). The interval pills are updated in place, so keyboard focus survives an interval change;
   they are rebuilt only when the plan list itself changes (a size switch), and focus is then put back. */
(function () {
  'use strict';
  function q(s, r) { return (r || document).querySelector(s); }
  function qa(s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); }
  function C() { return window.CHS2 || {}; }
  function money(c) { var f = C().money; if (f) return f(c); c = Math.round(c); return '$' + (c % 100 ? (c / 100).toFixed(2) : String(c / 100)); }
  function planMonths(n) {
    var f = C().planMonths; if (f) return f(n);
    var m = /(\d+)\s*day/i.exec(n || ''); if (m) return Math.max(1, Math.round(+m[1] / 30));
    m = /(\d+)\s*month/i.exec(n || ''); if (m) return +m[1];
    m = /(\d+)\s*week/i.exec(n || ''); if (m) return Math.max(1, Math.round(+m[1] / 4.3));
    return 1;
  }
  function fill(t, map) { return String(t || '').replace(/\[(\w+)\]/g, function (m, k) { return Object.prototype.hasOwnProperty.call(map, k) ? map[k] : m; }); }
  function cap(s) { return s.charAt(0).toUpperCase() + s.slice(1); }
  function setO(root, k, v) { qa('[data-sx-o="' + k + '"]', root).forEach(function (e) { e.textContent = v; }); }
  function setWas(root, k, v) { setO(root, k, v); var w = q('[data-sx-wrap="' + k + '"]', root); if (w) w.hidden = !v; }

  function Box(root) {
    if (root.sxBound) return;
    var el = q('[data-sx-data]', root); if (!el) return;
    var D; try { D = JSON.parse(el.textContent); } catch (e) { return; }
    var V = D.variants || []; if (!V.length) return;
    root.sxBound = true;
    var T = D.labels || {};
    function every(mo) { return mo === 1 ? T.everyOne || 'every month' : fill(T.everyN || 'every [n] months', { n: mo }); }
    function pill(mo, short) { return mo === 1 ? T.pillOne || 'Monthly' : fill((short ? T.pillShort : T.pillN) || 'Every [n] months', { n: mo }); }
    function thenLine(plan) {
      var e = every(planMonths(plan.name)), m = { every: e, Every: cap(e), price: money(plan.then) };
      return plan.then !== plan.price ? fill(T.then || 'First order, then [price] [every]', m) : fill(T.same || '[Every], same price each delivery', m);
    }
    function getV(id) { for (var i = 0; i < V.length; i++) if (V[i].id === id) return V[i]; return V[0]; }
    function plansOf(v) { return (v.plans || []).slice().sort(function (a, b) { return planMonths(a.name) - planMonths(b.name); }); }
    var v0 = getV(+root.getAttribute('data-sx-cur-v'));
    var st = { vid: v0.id, mode: root.getAttribute('data-sx-cur-m') === 'sub' && plansOf(v0).length ? 'sub' : 'one', plan: +root.getAttribute('data-sx-cur-p') || null };
    var subOpt = q('[data-sx-opt="sub"]', root), oneOpt = q('[data-sx-opt="one"]', root), cads = q('[data-sx-cads]', root), add = q('button[data-sx-add]', root);

    function curPlan(v) {
      var ps = plansOf(v); if (!ps.length) return null;
      for (var i = 0; i < ps.length; i++) if (ps[i].id === st.plan) return ps[i];
      // no plan chosen for this size yet: the default interval, else the longest one under it, else the shortest
      var want = D.defMonths || 1, best = null;
      ps.forEach(function (p) { var m = planMonths(p.name); if (m <= want && (!best || m > planMonths(best.name))) best = p; });
      return best || ps[0];
    }
    function pillButton(p) {
      var mo = planMonths(p.name), b = document.createElement('button'), l = document.createElement('span'), s = document.createElement('span');
      b.type = 'button'; b.setAttribute('data-sx-plan', p.id); b.setAttribute('aria-pressed', 'false');
      l.className = 'sx-cad-l'; l.textContent = pill(mo);
      s.className = 'sx-cad-s'; s.setAttribute('aria-hidden', 'true'); s.textContent = pill(mo, true);
      b.appendChild(l); b.appendChild(s); return b;
    }
    function render() {
      var v = getV(st.vid), ps = plansOf(v), plan = curPlan(v);
      if (!plan && st.mode === 'sub') st.mode = 'one';
      var sub = st.mode === 'sub';
      if (plan) st.plan = plan.id;
      var pay = sub ? plan.price : v.price;
      qa('button[data-sx-size]', root).forEach(function (b) { b.setAttribute('aria-checked', String(+b.getAttribute('data-sx-size') === v.id)); });
      if (subOpt) {
        subOpt.hidden = !ps.length;
        subOpt.setAttribute('data-on', String(sub));
        var hs = q('button[data-sx-mode="sub"]', subOpt); hs.setAttribute('aria-checked', String(sub)); hs.tabIndex = sub ? 0 : -1;
        if (plan) {
          setO(subOpt, 'first', money(plan.price));
          setWas(subOpt, 'was', plan.price < v.price ? money(v.price) : '');
          setO(subOpt, 'then', thenLine(plan));
          setO(subOpt, 'subtitle', D.subTitle || v.group || '');
        }
        if (cads) {
          var want = ps.map(function (p) { return String(p.id); }).join(','),
              have = qa('button[data-sx-plan]', cads).map(function (b) { return b.getAttribute('data-sx-plan'); }).join(',');
          if (want !== have) {
            var hadFocus = cads.contains(document.activeElement);
            while (cads.firstChild) cads.removeChild(cads.firstChild);
            ps.forEach(function (p) { cads.appendChild(pillButton(p)); });
            cads.style.setProperty('--nc', ps.length);
            if (hadFocus) { var f = (plan && q('button[data-sx-plan="' + plan.id + '"]', cads)) || q('button', cads); if (f) f.focus(); }
          }
          // pressed = the interval in use; with One-time chosen no pill is pressed, but the pills keep their place
          qa('button[data-sx-plan]', cads).forEach(function (b) { b.setAttribute('aria-pressed', String(sub && !!plan && +b.getAttribute('data-sx-plan') === plan.id)); });
          cads.hidden = ps.length < 2;
        }
      }
      if (oneOpt) {
        oneOpt.setAttribute('data-on', String(!sub));
        var ho = q('button[data-sx-mode="one"]', oneOpt); ho.setAttribute('aria-checked', String(!sub)); ho.tabIndex = sub ? -1 : 0;
        setO(oneOpt, 'one', money(v.price));
        setWas(oneOpt, 'onewas', v.compare > v.price ? money(v.compare) : '');
      }
      // the subscription-only tick keeps its place while One-time is chosen (invisible, not removed), so the card never
      // changes height on a switch and nothing on the page moves
      var tick = q('[data-sx-subtick]', root); if (tick) tick.toggleAttribute('data-off', !sub);
      if (add) {
        add.disabled = !v.available;
        if (v.available) {
          if (!q('[data-sx-o="cta"]', add)) add.innerHTML = '<span data-sx-o="ctalabel"></span> &middot; <span data-sx-o="cta"></span>';
          setO(add, 'ctalabel', sub && D.ctaSub ? D.ctaSub : D.cta || 'Add to cart'); setO(add, 'cta', money(pay));
        } else add.textContent = D.soldout || 'Sold out';
      }
      root.setAttribute('data-sx-cur-v', v.id); root.setAttribute('data-sx-cur-m', st.mode);
      root.setAttribute('data-sx-cur-p', sub && plan ? plan.id : ''); root.setAttribute('data-sx-cur-pay', pay);
    }
    function lineItem() {
      var v = getV(st.vid), plan = st.mode === 'sub' ? curPlan(v) : null;
      var item = { id: v.id, quantity: 1, properties: { _pdp: D.tag || 'v2' } };
      if (plan) item.selling_plan = plan.id;
      return item;
    }
    root.sxItem = lineItem; // read-only: the exact line the button posts (used by QA)
    function addToCart() {
      var v = getV(st.vid); if (!v.available || !add || add.getAttribute('aria-busy') === 'true') return;
      var item = lineItem(), post = C().postAdd, err = T.err || 'Could not add to cart. Please try again.';
      if (!post) { setO(root, 'err', err); return; }
      add.setAttribute('aria-busy', 'true'); setO(root, 'err', '');
      post([item]).then(function () { var c = C(); if (c.refreshCount) c.refreshCount(); if (c.openCart) c.openCart(); })
        .catch(function (e) { setO(root, 'err', e && e.message ? e.message : err); })
        .then(function () { add.removeAttribute('aria-busy'); });
    }
    root.addEventListener('click', function (e) {
      var b;
      if ((b = e.target.closest('button[data-sx-size]'))) { st.vid = +b.getAttribute('data-sx-size'); return render(); }
      if ((b = e.target.closest('button[data-sx-plan]'))) { st.plan = +b.getAttribute('data-sx-plan'); st.mode = 'sub'; return render(); }
      if ((b = e.target.closest('button[data-sx-mode]'))) { st.mode = b.getAttribute('data-sx-mode'); return render(); }
      if (e.target.closest('button[data-sx-add]')) { addToCart(); }
    });
    root.addEventListener('keydown', function (e) {
      var b = e.target.closest('button[data-sx-mode]'), keys = ['ArrowDown', 'ArrowUp', 'ArrowLeft', 'ArrowRight'];
      if (b && keys.indexOf(e.key) >= 0 && subOpt && !subOpt.hidden) {
        e.preventDefault(); st.mode = st.mode === 'sub' ? 'one' : 'sub'; render();
        var f = q('button[data-sx-mode="' + st.mode + '"]', root); if (f) f.focus(); return;
      }
      var s = e.target.closest('button[data-sx-size]');
      if (s && keys.indexOf(e.key) >= 0) {
        var all = qa('button[data-sx-size]:not([disabled])', root), i = all.indexOf(s);
        e.preventDefault(); var n = all[(i + (e.key === 'ArrowRight' || e.key === 'ArrowDown' ? 1 : all.length - 1)) % all.length];
        st.vid = +n.getAttribute('data-sx-size'); render(); n.focus();
      }
    });
    render();
  }

  function boot(scope) { qa('[data-sx-box]', scope).forEach(Box); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { boot(); }); else boot();
  // theme editor: a re-rendered section comes back as new markup, so bind its box again
  document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
})();
